import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src39902398/src/Camouflage-frontend/src/app/[lang]/(withHeader)/product/_componets/ProductDetails.tsx");
